import { Component, OnInit } from '@angular/core';
import { HelperProvider } from '../providers/helper.provider';
import { Page } from '../model/page';
import { RestService } from '../providers/rest.service';
import { Kullanici } from '../model/kullanici';
import { Router } from '@angular/router';

@Component({
  selector: 'app-kullanicilar',
  templateUrl: './kullanicilar.component.html',
  styleUrls: ['./kullanicilar.component.css']
})
export class KullanicilarComponent implements OnInit {
  kullanicilar: Kullanici[] = null;

  constructor(private helperProvider: HelperProvider,
    private restService: RestService,
    private router: Router) {
  }

  ngOnInit(): void {
    this.helperProvider.currentPage$.next(Page.Kullanicilar);
    this.getKullanicilar(true);
  }

  getKullanicilar(check: boolean) {
    if (check) {
      this.restService.kullanicilar().subscribe(res => {
        if (res != null) {
          this.kullanicilar = res;
        }
      }, error => {
        this.helperProvider.showConnectionError$.next(true);
      });
    }
  }

  new() {
    this.router.navigate(['kullanici'], { queryParams: { id: '0' } });
  }
}
